import { afterNextRender, Component, DestroyRef, ElementRef, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AccessibilityStateService } from '../../../core/services/accessibility-state.service';
import { ApiAuthService } from '../../../services/backend/public/api-auth/api-auth.service';

@Component({
  selector: 'sr-psa-govco-header',
  standalone: true,
  templateUrl: './govco-header.component.html',
  styleUrl: './govco-header.component.css',
  imports: [RouterLink]
})
export class GovcoHeaderComponent {
  private readonly document = inject(DOCUMENT);
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);
  readonly accessibility = inject(AccessibilityStateService);
  readonly auth = inject(ApiAuthService);
  private scale = 0;
  constructor() {
    afterNextRender(() => {
      const updateHeight = () => this.document.documentElement.style.setProperty(
        '--app-header-height', `${this.element.nativeElement.getBoundingClientRect().height}px`
      );
      const observer = new ResizeObserver(updateHeight);
      observer.observe(this.element.nativeElement);
      updateHeight();
      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }
  setScale(change: number): void {
    this.scale = Math.max(-1, Math.min(2, this.scale + change));
    this.document.documentElement.style.setProperty('--font-scale', `${1 + this.scale * .12}`);
  }
  toggleContrast(): void { this.document.body.classList.toggle('high-contrast'); }
}
